import React, {useState, useEffect} from "react";
import {
    Typography,
    Card,
    CardHeader,
    CardBody,
    Button,
    Textarea,
    Select,
    Option,
} from "@material-tailwind/react";
import RoleForm from '../shared/role_form';
import SideNav from "../layout/sidenav";
import NavBar from "../layout/navbar";
import Footer from "../layout/footer";
import InputMask from "react-input-mask";
import axios from "axios";

const NewDiscountLot = ({routes, username, role}) => {
    const [openSidenav, setOpenSidenav] = useState(false);
    const [discounts, setDiscounts] = useState([]);
    const [selectedDiscount, setSelectedDiscount] = useState("");
    const [parcelCode, setParcelCode] = useState("");
    const [notes, setNotes] = useState(null);
    const [error, setError] = useState(null)

    const loadDiscounts = async () => {
        try {
            const response = await fetch(`/discounts/get_special_discounts.json`);
            if (!response.ok) {
                console.log("No se encontraron descuentos.");
                return;
            }
            const data = await response.json();
            setDiscounts(data);
        } catch (err) {
            console.error("Error al buscar descuentos especiales activos:", err);
        }
    }

    const toggleDiscount = (e) => {
        console.log('Pre Option: ', e);
        console.log('Pre Selected: ', selectedDiscount);
        const selectedId = e
        setSelectedDiscount(selectedId);
    }

    const handleSave = async () => {
        await axios.post(`/discount_lots.json`, {
            parcel_code: parcelCode,
            notes: notes,
            discount_id: selectedDiscount
        }, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(function(response) {
            window.location.href = '/discounts';
        }).catch(function (error) {
            setError(error.data);
        });
    }

    return (
        <>
            {/*<SideNav setOpenSidenav={setOpenSidenav} openSidenav={openSidenav} roleKey={role}/>*/}
            {/*<div className="p-4 xl:ml-80">*/}
            {/*    <NavBar*/}
            {/*        routes={routes}*/}
            {/*        setOpenSidenav={setOpenSidenav}*/}
            {/*        openSidenav={openSidenav}*/}
            {/*        userName={username}*/}
            {/*    />*/}
                <div className="mt-12">
                    <div className="mb-4 grid grid-cols-1 gap-6 xl:grid-cols-1">
                        <Card className="overflow-hidden xl:col-span-2 border border-blue-gray-100 shadow-sm">
                            <CardHeader
                                floated={false}
                                shadow={false}
                                color="transparent"
                                className="m-0 flex items-center justify-between p-6"
                            >
                                <div>
                                    <Typography variant="h6" color="blue-gray" className="mb-1">
                                        Alta descuento especial
                                    </Typography>
                                </div>
                            </CardHeader>
                            <CardBody className="overflow-x-scroll px-0 pt-0 pb-2 mx-6">
                                <form className="mt-0 mb-2 w-100 max-w-screen-lg sm:w-96">
                                    <div className="mb-1 flex flex-col gap-6">
                                        <Typography variant="h6" color="blue-gray" className="-mb-3">
                                            Clave catastral
                                        </Typography>
                                        <InputMask
                                            mask="519999-999-999"
                                            value={parcelCode}
                                            onChange={(e) => setParcelCode(e.target.value)}
                                        >
                                            {(inputProps) => (
                                                <input
                                                    {...inputProps}
                                                    type="text"
                                                    placeholder="51XXXX-XXX-XXX"
                                                    className="p-2 w-full border border-gray-300 rounded"
                                                />
                                            )}
                                        </InputMask>
                                        <Typography variant="h6" color="blue-gray" className="-mb-3">
                                            Descuento
                                        </Typography>
                                        <Select
                                            variant="outlined"
                                            label="Seleccione descuento"
                                            value={selectedDiscount}
                                            onChange={(e) => {
                                                toggleDiscount(e)
                                            }}
                                            onClick={loadDiscounts}
                                        >
                                            {discounts.map((discount, index) => (
                                                <Option key={discount.id} value={discount.id.toString()}>{discount.percentage}% - {discount.name}</Option>
                                            ))}
                                        </Select>
                                        <Typography variant="h6" color="blue-gray" className="-mb-3">
                                            Notas
                                        </Typography>
                                        <Textarea size="lg" onChange={(e) => {
                                            setNotes(e.target.value)
                                        }}/>
                                    </div>
                                    {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
                                    <Button className="mt-6" fullWidth onClick={handleSave}>
                                        Enviar
                                    </Button>
                                </form>
                            </CardBody>
                        </Card>
                    </div>
                </div>
            {/*    <Footer/>*/}
            {/*</div>*/}
        </>
    );
};

export default NewDiscountLot;